import * as types from "../mutationTypes"
import Import from '../../services/import'

let state = {
    importKey: '',
    importedRows: null,
    importedJobTasks: null,
    importedRow: null,
    deletedImportKey: null,
    headers: [
        { text: 'Order' , value: 'order' },
        { text: 'Description', value: 'workOrderDescription' },
        { text: 'Notes', value: 'notes' },
        { text: 'Due Date', value:'dueDate' },
        { text: 'Issue Date', value:'issueDate' }
    ],
    error: null
}
const getters = {
    importKey (state) {
        return state.importKey
    },
    importedRows (state) {
        return state.importedRows
    },
    importedJobTasks (state) {
        return state.importedJobTasks
    },
    importedRow (state) {
        return state.importedRow
    },
    deleteImportKey (state) {
        return state.deletedImportKey
    },
    headers (state) {
        return state.headers
    },
    error (state) {
        return state.error
    }
}
const actions = {

    async stageFile ({ commit }, file) {
        try {
            let res = await Import.uploadStageFile(file)
            if (res) {
                await commit(types.CLEAR_PREVIOUS_UPLOAD)
                await commit(types.REQUEST_STAGE_FILE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_STAGE_FILE_ERROR, error.message)
        }
    },
    async importFileForTaskTable({ commit }, importKey) {
        try {
            let res = await Import.importFile(importKey)
            if (res) {
                commit(types.REQUEST_IMPORT_FILE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_IMPORT_FILE_ERROR, error.message)
        }
    },
    async getRows({ commit }, keywords) {
        try {
            let res = await Import.getRows(keywords)
            if (res) {
                commit(types.REQUEST_GET_ROWS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ROWS_ERROR, error.message)
        }
    },
    async getKeys({ commit }, identifier) {
        try {
            let res = await Import.getKeys(identifier)
            if (res) {
                commit(types.REQUEST_GET_KEYS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_KEYS_ERROR, error.message)
        }
    },
    async deleteInput({ commit }, importKey) {
        try {
            let res = await Import.deleteInputSet(importKey)
            if (res) {
                commit(types.REQUEST_DELETE_INPUT_SET_SUCCESS, res.data)
            }
        }
        catch (error) {
            commit(types.REQUEST_DELETE_INPUT_SET_ERROR, error.message)
        }
    }
}
const mutations = {
    [types.REQUEST_STAGE_FILE_SUCCESS] (state, importedRows) {
        console.log(importedRows)
        for(let i = 0; i < importedRows.length; i++) {
            importedRows[i].notes = importedRows[i].oprShortText ?? importedRows[i].opShortText
        }
        console.log(importedRows)
        state.importedRows = importedRows
        state.error = null
    },
    [types.REQUEST_STAGE_FILE_ERROR] (state, message) {
        state.importedRows = null
        state.error = message
    },
    [types.REQUEST_IMPORT_FILE_SUCCESS] (state, importedJobTasks) {
        state.importedJobTasks = importedJobTasks
        state.error = null
    },
    [types.REQUEST_IMPORT_FILE_ERROR] (state, message) {
        state.importedJobTasks = null
        state.error = message
    },
    [types.REQUEST_GET_ROWS_SUCCESS] (state, importedRows) {
        state.importedRows = importedRows
        state.error = null
    },
    [types.REQUEST_GET_ROWS_ERROR] (state, message) {
        state.importedRows = null
        state.error = message
    },
    [types.REQUEST_GET_KEYS_SUCCESS] (state, importedRows) {
        state.importedRows = importedRows
        state.error = null
    },
    [types.REQUEST_GET_KEYS_ERROR] (state, message) {
        state.importedRows = null
        state.error = message
    },
    [types.REQUEST_DELETE_INPUT_SET_SUCCESS] (state, deletedImportKey) {
        state.deletedImportKey = deletedImportKey
        state.error = null
    },
    [types.REQUEST_DELETE_INPUT_SET_ERROR] (state, message) {
        state.deletedImportKey = null
        state.error = message
    },
    [types.CLEAR_PREVIOUS_UPLOAD] (state) {
        state.importedRows = []
        state.importedJobTasks = []
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
